export type SpotLieClaim = { text: string; isLie: boolean; conceptId: string };
export type SpotLieRound = { intro: string; claims: SpotLieClaim[] };

const S = "scene_safety";
const B = "bleeding_basic";
const E = "emergency_call";
const R = "recovery_position";

export const FIRST_AID_SPOTLIE_DECK: readonly SpotLieRound[] = [
  {
    intro: "First day of a community first-aid talk:",
    claims: [
      {
        text: "You should scan for hazards before you reach the person.",
        isLie: false,
        conceptId: S,
      },
      {
        text: "It is always safe to move someone who might have a neck injury without help.",
        isLie: true,
        conceptId: S,
      },
      { text: "Smoke or downed power lines can make a scene unsafe.", isLie: false, conceptId: S },
    ],
  },
  {
    intro: "About bleeding:",
    claims: [
      {
        text: "Steady pressure with a clean cloth is a common first step.",
        isLie: false,
        conceptId: B,
      },
      {
        text: "You should remove pressure every few seconds to ‘air’ the wound.",
        isLie: true,
        conceptId: B,
      },
      { text: "Heavy or spurting bleeding can be an emergency.", isLie: false, conceptId: B },
    ],
  },
  {
    intro: "Calling for help:",
    claims: [
      { text: "Location and what happened are useful to dispatchers.", isLie: false, conceptId: E },
      {
        text: "You must guess a formal medical diagnosis on the phone.",
        isLie: true,
        conceptId: E,
      },
      {
        text: "Staying on the line can be important if they ask you to.",
        isLie: false,
        conceptId: E,
      },
    ],
  },
  {
    intro: "Recovery position:",
    claims: [
      {
        text: "It can help keep an unconscious but breathing person’s airway open.",
        isLie: false,
        conceptId: R,
      },
      { text: "It replaces CPR when someone is not breathing.", isLie: true, conceptId: R },
      { text: "Training matters for when and how to roll someone.", isLie: false, conceptId: R },
    ],
  },
  {
    intro: "Scene safety sound bite:",
    claims: [
      {
        text: "Your safety matters too—do not become a second victim.",
        isLie: false,
        conceptId: S,
      },
      {
        text: "You should always enter a burning building alone to be brave.",
        isLie: true,
        conceptId: S,
      },
      {
        text: "If unsure, call professionals and follow your course rules.",
        isLie: false,
        conceptId: E,
      },
    ],
  },
  {
    intro: "Bleeding myths:",
    claims: [
      {
        text: "Putting direct pressure is a standard first step for many cuts.",
        isLie: false,
        conceptId: B,
      },
      { text: "Butter or random pastes should go on an open wound.", isLie: true, conceptId: B },
      {
        text: "Get trained help for bleeding you cannot control with pressure.",
        isLie: false,
        conceptId: B,
      },
    ],
  },
];
